import { httpRequest } from "../../http";

export class CommandSaveCatalogSettings{
    async run(storeSettings: any, organizationId: number, pageName: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/store/pages/config/`
        try {
            const response = await httpRequest<any>(url, { method: "POST", body: { ...storeSettings, page_name: pageName } });
            if(response) {
                console.log(response);
                return response;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}
